import React from 'react';
import ProductCategoryForm from 'forms/ProductCategoryForm';

export default (): JSX.Element => <ProductCategoryForm />;
